import { Controller } from "@hotwired/stimulus"

// Debounced-save for a single text input in the welcome modal.
// data-values: url (PATCH endpoint), field (param name)
export default class extends Controller {
  static values = { url: String, field: String }

  save(event) {
    clearTimeout(this._timer)
    this._timer = setTimeout(() => this.persist(event.target.value), 400)
  }

  submit(event) {
    event.preventDefault()
    const input = this.element.querySelector("input")
    if (input) this.persist(input.value)
  }

  async persist(value) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new URLSearchParams()
    body.set(this.fieldValue, value)
    try {
      await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token,
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "application/json"
        },
        credentials: "same-origin",
        body: body.toString()
      })
    } catch {
      /* soft-fail */
    }
  }
}
